<div class="inputGrid w-full pt-2">
    <app-input-fulltext
        [form]="form"
        [options]="store.workRecords()"
        (selectedOptionChange)="workDataChange($event)"
    ></app-input-fulltext>
    <app-button
        [disabled]="!store.isAllowed('continuousReport.create')() || folderStore.isTerminated()"
        (clickEvent)="continuousRecordFormComponent()?.save()"
        [loading]="store.loadingAny()"
        icon="pi-save"
        label="inputs.save"
        class="white-space-nowrap"
    ></app-button>
    <app-button
        icon="pi-print"
        [severity]="'secondary'"
        label="folder.carePlan.action.print"
        class="white-space-nowrap justify-self-end"
        (clickEvent)="print()"
    ></app-button>

    <app-work-continuous-record
        #continuousRecordForm
        [folder]="folderStore.folder()"
        class="left-container"
    ></app-work-continuous-record>

    <p-listbox class="fr-2 h-full"
        [options]="store.workRecords()"
        [(ngModel)]="selectWorkData"
        (onChange)="listChange($event)"
        [filter]="true"
        [filterPlaceHolder]="'database.persons.history' | translate"
        emptyMessage="{{'database.persons.noResultsFound' | translate}}"
        optionLabel="key"
        dataKey="index"
        scrollHeight="calc(100vh - 20rem)"
    >
        <ng-template let-records pTemplate="item">
            <div (contextmenu)="rightClick(contextMenu, $event, records)" class="w-full h-full">
                <div class="flex-column gap-x-small">
                    <div>{{ records.createdAt }}</div>
                    @if (records.users && records.users.length > 0) {
                        <app-user-chip [user]="records.users![0]"></app-user-chip>
                    }
                </div>
            </div>
        </ng-template>
    </p-listbox>
</div>

<p-contextMenu
    #contextMenu
    [model]="contextMenuItems"
    appendTo="body"
    styleClass="continuous-record-context-menu"
></p-contextMenu>
